export default __webpack_public_path__ + "static/poster-6bcdd96e5552d278ace1c3d901c56e0d.png";